import React, { lazy, Suspense } from 'react';
import BannerSection from "../../components/BannerSection";
import { Loader } from '../../components/Loader';
import MetaTags from '../../components/MetaTags';
import { imagePath } from '../../Utils/WHL/helpers';
const DocumentAccordion = lazy(() => import('../../components/NonQM/DocumentAccordion'));
const Body = lazy(() => import('../../components/Body'));
const Disclaimer = lazy(() => import('../../components/NonQMDisclaimer'));

const NonQM = ({
    pageDetails
}) => {
    return (
        <>
            <MetaTags
                url={process.env.REACT_APP_NON_QM_PRODUCTS}
                ogImagePath={`${imagePath}/previewImages/nonqm_preview.jpg`}
                keywords={'wholesale loans, loan rates, mortgage loan, home loan, fast loan, nonqm, nonqm loans'}
                description={'With common sense underwriting your loans close fast. View exceptional pricing, current turn times, features and the NonQM products available at Sun West Mortgage.'}
            />
            <BannerSection pageDetails = { pageDetails } />
            {/* <Disclaimer /> */}
            <Suspense fallback={<Loader />}>
                <Body pageDetails={pageDetails} DocumentAccordion={
                    <Suspense fallback={<Loader />}>
                        <DocumentAccordion />
                    </Suspense>
                } />
            </Suspense>
            
         
         <Suspense fallback={<Loader />}>
           <Disclaimer />
         </Suspense>          
        </>
    );
}
 
export default NonQM;